import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitobhopalcab() {



const cardData = {
  keyword: " Mumbai to Bhopal Cab",

headingDescription:
  "Omshree Cab offers reliable and comfortable Mumbai to Bhopal cab services for travelers planning a long-distance journey between Maharashtra and Madhya Pradesh. Whether you are traveling for business, family visits, tourism, or a spiritual trip, our cab service ensures a safe and hassle-free experience with experienced drivers and well-maintained vehicles. The road distance between Mumbai and Bhopal is approximately 985 km, making a private cab one of the most convenient ways to travel comfortably across states. We provide flexible booking options including one-way trips, round-trip packages, and multi-day travel plans with transparent per-kilometer pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With punctual pickup from anywhere in Mumbai, experienced chauffeurs familiar with long highway routes, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Bhopal cab booking.",

topPlaces: [
  {
    title: "Upper Lake (Bada Talab)",
    description:
      "Upper Lake, also known as Bada Talab, is one of the most famous attractions in Bhopal and is often considered the heart of the city. The lake offers beautiful views, boating experiences, lakeside promenades, and scenic sunset spots where visitors can relax and enjoy nature. Travelers often enjoy boat rides, lakeside cafes, and photography while watching the calm waters and surrounding hills. Visiting the lake by cab allows tourists to comfortably explore the surrounding attractions and spend time enjoying Bhopal’s peaceful waterfront environment."
  },
  {
    title: "Van Vihar National Park",
    description:
      "Van Vihar National Park is a large wildlife sanctuary located beside the Upper Lake in Bhopal. The park is home to many animals such as deer, tigers, leopards, and numerous bird species, making it a popular destination for nature lovers and wildlife enthusiasts. Visitors can explore the park through walking trails or safari routes while enjoying the greenery and natural surroundings. Traveling by cab ensures easy access to this attraction and allows travelers to plan enough time for wildlife viewing and nature exploration."
  },
  {
    title: "Sanchi Stupa",
    description:
      "Sanchi Stupa is one of the most important Buddhist monuments in India and is located near Bhopal. Built by Emperor Ashoka in the 3rd century BCE, the site features ancient stupas, monasteries, and beautifully carved gateways that depict scenes from Buddhist history. The monument is recognized as a UNESCO World Heritage Site and attracts visitors from around the world interested in history and spirituality. A comfortable cab journey from Mumbai to Bhopal allows travelers to easily include this historic landmark in their itinerary."
  },
  {
    title: "Birla Mandir (Lakshmi Narayan Temple)",
    description:
      "Birla Mandir, also known as the Lakshmi Narayan Temple, is a beautiful hilltop temple dedicated to Lord Vishnu and Goddess Lakshmi. Located near Arera Hills in Bhopal, the temple offers stunning views of the city and nearby lakes. The temple complex also includes a museum displaying ancient sculptures and artifacts from different parts of Madhya Pradesh. Visitors traveling by cab can conveniently reach the temple and enjoy both spiritual experiences and panoramic city views. :contentReference[oaicite:0]{index=0}"
  },
  {
    title: "Bharat Bhavan",
    description:
      "Bharat Bhavan is a renowned multi-arts complex in Bhopal that promotes visual arts, theatre, literature, and music. The center features art galleries, a museum of tribal and folk art, a theatre auditorium, and open-air performance spaces overlooking the Upper Lake. Cultural enthusiasts often visit Bharat Bhavan to experience exhibitions, performances, and artistic workshops. Traveling by cab makes it easy to include this cultural hub in your sightseeing tour while exploring the artistic side of Bhopal. :contentReference[oaicite:1]{index=1}"
  },
  {
    title: "Indira Gandhi Rashtriya Manav Sangrahalaya",
    description:
      "Indira Gandhi Rashtriya Manav Sangrahalaya, also known as the National Museum of Humankind, is one of the largest anthropological museums in India. Spread over around 200 acres on Shymala Hills, the museum showcases the evolution of human culture through open-air exhibits, traditional tribal dwellings, and indoor galleries. Visitors can explore different cultural displays that highlight the diversity of Indian communities and lifestyles. A cab ride provides convenient access to this vast museum complex, allowing visitors to explore it comfortably. :contentReference[oaicite:2]{index=2}"
  },
  {
    title: "Shaurya Smarak",
    description:
      "Shaurya Smarak is a war memorial in Bhopal dedicated to the bravery and sacrifices of Indian armed forces personnel. The memorial features artistic installations, landscaped gardens, and a towering sculpture known as the Shaurya Stambh that symbolizes the courage of the Indian Army, Navy, and Air Force. Visitors often explore the park to learn about military history and admire its impressive architecture. Traveling by cab allows visitors to comfortably include this meaningful landmark in their city tour. :contentReference[oaicite:3]{index=3}"
  },
  {
    title: "Sair Sapata",
    description:
      "Sair Sapata is a popular recreational and entertainment complex located along the banks of the Upper Lake in Bhopal. The attraction includes a musical fountain, suspension bridge, toy train rides, children’s play areas, and scenic viewpoints overlooking the lake. Families and tourists often visit for relaxation, evening walks, and fun activities while enjoying the lakeside atmosphere. A cab trip ensures convenient access to this entertainment destination and allows visitors to explore nearby attractions along the lakefront. :contentReference[oaicite:4]{index=4}"
  },
  {
    title: "State Museum Bhopal",
    description:
      "The State Museum in Bhopal is an important cultural attraction that showcases the rich history and heritage of Madhya Pradesh. The museum houses thousands of artifacts including sculptures, paintings, coins, tribal art, and archaeological findings that highlight the region’s cultural evolution. Visitors interested in art, history, and archaeology often spend hours exploring the galleries and learning about the state’s traditions. Traveling by cab allows tourists to comfortably include this educational destination in their Bhopal sightseeing itinerary. :contentReference[oaicite:5]{index=5}"
  },
  {
    title: "Taj-ul-Masajid",
    description:
      "Taj-ul-Masajid is one of the largest mosques in India and a significant architectural landmark in Bhopal. Known for its grand domes, tall minarets, and beautiful pink facade, the mosque reflects Mughal-influenced architecture and historical significance. Visitors admire the spacious courtyard, intricate carvings, and peaceful atmosphere. A cab journey to Bhopal allows travelers to easily visit this magnificent mosque along with other nearby historical and cultural attractions."
  }
],



services: [
{
name: "Mumbai to Bhopal Cab",
description: "Mumbai to Bhopal cab service offers comfortable long-distance transportation between Maharashtra and Madhya Pradesh for tourists, business travelers, and families. The route connects major highways ensuring smooth interstate travel with experienced drivers who are familiar with long-distance road conditions. Vehicles are well maintained and designed for highway journeys with spacious seating and luggage capacity. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Mumbai. Ideal for tourism trips, family travel, and corporate journeys. Air-conditioned vehicles ensure comfortable travel throughout the journey. Flexible booking options allow convenient ride scheduling and travel planning."
},
{
name: "Mumbai to Bhopal Taxi",
description: "Mumbai to Bhopal taxi service provides reliable transportation for passengers traveling between the two major cities for tourism, business, or family visits. Vehicles are designed for long-distance highway journeys and offer comfortable seating with ample luggage space. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup is available from homes, offices, hotels, railway stations, and airport terminals. Ideal for long-distance travel, intercity trips, and tourism journeys. Air-conditioned interiors ensure relaxed and comfortable travel experiences. Flexible taxi booking options allow passengers to easily schedule rides."
},
{
name: "Mumbai to Bhopal Cab Service",
description: "Mumbai to Bhopal cab service provides dependable transportation for passengers planning interstate travel between Mumbai and Bhopal. Vehicles are suitable for long-distance highway journeys and provide comfortable seating for families and groups. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for tourism travel, business trips, and family visits. Comfortable interiors ensure relaxed journeys throughout the trip. Flexible booking options allow convenient cab reservations anytime."
},
{
name: "Mumbai to Bhopal Taxi Service",
description: "Mumbai to Bhopal taxi service offers convenient travel solutions for passengers visiting Bhopal for tourism, business, or family purposes. Vehicles are suitable for long highway journeys and provide smooth driving performance and spacious seating. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airports. Ideal for tourism visits, corporate travel, and long-distance journeys. Air-conditioned vehicles ensure comfortable travel experiences. Flexible taxi booking options allow passengers to schedule rides easily."
},
{
name: "Cab from Mumbai to Bhopal",
description: "Cab from Mumbai to Bhopal offers comfortable interstate transportation for travelers planning long-distance journeys. Vehicles provide smooth highway performance and spacious seating suitable for extended travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for family trips, tourism travel, and corporate journeys. Comfortable vehicles ensure relaxed travel experiences throughout the journey. Flexible booking options allow convenient ride reservations."
},
{
name: "Taxi from Mumbai to Bhopal",
description: "Taxi from Mumbai to Bhopal provides reliable transportation for passengers traveling to the capital city of Madhya Pradesh. Vehicles are designed for long-distance highway journeys and offer comfortable seating for passengers and luggage. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for tourism visits, family trips, and corporate travel. Air-conditioned vehicles ensure comfortable journeys. Flexible taxi booking options allow passengers to easily schedule rides."
},
{
name: "Mumbai to Bhopal Cab Booking",
description: "Mumbai to Bhopal cab booking allows travelers to easily reserve vehicles for long-distance interstate travel. Online and phone booking options provide instant confirmation and convenient ride scheduling. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for family travel, tourism journeys, and corporate trips. Comfortable vehicles ensure relaxed travel experiences. Flexible booking options allow passengers to schedule rides conveniently."
},
{
name: "Mumbai to Bhopal Taxi Booking Online",
description: "Mumbai to Bhopal taxi booking online provides convenient digital reservations for travelers planning long-distance journeys. Passengers can easily schedule pickups and receive instant confirmation for their travel plans. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for families, tourists, and corporate travelers. Air-conditioned vehicles ensure comfortable travel experiences. Flexible online booking options allow easy travel planning."
},
{
name: "Mumbai to Bhopal Cab Price",
description: "Mumbai to Bhopal cab price options provide transparent fare estimates for passengers planning long-distance travel. Pricing depends on vehicle category, distance, and travel duration. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for tourism travel, family visits, and corporate trips. Comfortable vehicles ensure relaxed journeys. Transparent pricing ensures easy budgeting and travel planning."
},
{
name: "Mumbai to Bhopal Taxi Fare",
description: "Mumbai to Bhopal taxi fare services offer flexible pricing options depending on vehicle category and travel duration. Travelers can choose sedans, SUVs, or MPV vehicles based on comfort and group size. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for long-distance travel, family trips, and tourism visits. Comfortable interiors ensure relaxed journeys. Transparent fare structure allows easy travel planning."
},
{
name: "Mumbai to Bhopal One Way Cab",
description: "Mumbai to Bhopal one way cab service offers economical intercity transportation without return charges. Vehicles provide comfortable seating and smooth highway performance for long-distance travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for travelers visiting Bhopal for tourism or business trips. Air-conditioned vehicles ensure comfortable journeys. Flexible booking options allow quick ride reservations."
},
{
name: "Mumbai to Bhopal Round Trip Taxi",
description: "Mumbai to Bhopal round trip taxi service provides convenient transportation for travelers planning return journeys between the two cities. Vehicles are suitable for long-distance highway travel and multi-day trips. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for family visits, tourism travel, and business journeys. Comfortable interiors ensure relaxed journeys. Flexible round-trip packages allow convenient travel planning."
},
{
name: "Mumbai to Bhopal Innova Cab",
description: "Mumbai to Bhopal Innova cab service provides spacious MPV transportation suitable for families and groups traveling long distances. The Toyota Innova offers comfortable seating and excellent highway stability for interstate travel. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for family trips, tourism travel, and corporate journeys. Comfortable interiors ensure relaxed journeys. Flexible booking options allow convenient travel planning."
},
{
name: "Mumbai to Bhopal Ertiga Cab",
description: "Mumbai to Bhopal Ertiga cab service offers comfortable MPV transportation suitable for small groups and family travelers. The Maruti Ertiga provides spacious seating and smooth ride quality for long-distance highway travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for tourism travel, family visits, and corporate trips. Air-conditioned interiors ensure comfortable journeys. Flexible booking options allow easy ride reservations."
},
{
name: "Mumbai to Bhopal Sedan Cab",
description: "Mumbai to Bhopal sedan cab service provides economical and comfortable transportation for long-distance intercity travel. Sedan vehicles offer smooth driving performance and comfortable seating suitable for small families or business travelers. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for corporate trips, tourism travel, and family visits. Air-conditioned sedans ensure comfortable journeys. Flexible booking options allow convenient ride scheduling."
}
],

tableData: [
["Mumbai to Bhopal Cab","Mumbai to Bhopal Taxi"],
["Mumbai to Bhopal Cab Service","Mumbai to Bhopal Taxi Service"],
["Cab from Mumbai to Bhopal","Taxi from Mumbai to Bhopal"],
["Mumbai to Bhopal Cab Booking","Mumbai to Bhopal Taxi Booking Online"],
["Mumbai to Bhopal Cab Price","Mumbai to Bhopal Taxi Fare"],
["Mumbai to Bhopal One Way Cab","Mumbai to Bhopal Round Trip Taxi"],
["Mumbai to Bhopal Innova Cab","Mumbai to Bhopal Ertiga Cab"],
["Mumbai to Bhopal Sedan Cab","Intercity Cab Mumbai to Bhopal"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Long-Distance Drivers",
    WhyChoosedescription: "Our drivers are experienced in interstate highway travel from Mumbai to Bhopal. They are familiar with major routes across Maharashtra and Madhya Pradesh, ensuring a safe, smooth, and comfortable journey."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Omshree Cabs offers transparent pricing for Mumbai to Bhopal cab bookings. Customers receive clear information about per-kilometer charges, tolls, and driver allowance before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Service",
    WhyChoosedescription: "Our Mumbai to Bhopal cab service operates 24 hours a day. Whether you want to travel early morning or overnight, we provide reliable cab booking anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are well maintained, regularly cleaned, and fully air-conditioned to ensure passengers enjoy a comfortable long-distance journey."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Packages",
    WhyChoosedescription: "We offer flexible travel options including one-way cab booking, round trips, and multi-day travel packages from Mumbai to Bhopal."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers various vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for families and groups."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and airports anywhere in Mumbai so your Bhopal journey begins smoothly."
  },
  {
    WhyChooseheading: "Reliable Intercity Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by travelers for reliable intercity transportation. Our punctual drivers, comfortable vehicles, and professional service ensure a stress-free journey from Mumbai to Bhopal."
  }
]
};

const faqData = [
  { question: "Do you provide cab service from Mumbai to Bhopal?", answer: "Yes, Omshree Cabs provides reliable cab services from Mumbai to Bhopal for both one-way and round-trip travel." },
  { question: "What is the distance from Mumbai to Bhopal?", answer: "The distance from Mumbai to Bhopal is approximately 780 km and the journey usually takes around 14 to 16 hours depending on traffic and road conditions." },
  { question: "Can I book a one-way cab from Mumbai to Bhopal?", answer: "Yes, we offer both one-way and round-trip cab services for travel between Mumbai and Bhopal." },
  { question: "Which vehicles are available for this route?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers depending on group size." },
  { question: "Is the cab service available 24 hours?", answer: "Yes, our Mumbai to Bhopal cab service operates 24/7 for passenger convenience." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can we stop during the journey?", answer: "Yes, passengers can request stops during the journey for meals, rest, or refreshments." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended for long-distance routes like Mumbai to Bhopal." },
  { question: "Do you provide pickup from Mumbai Airport?", answer: "Yes, we provide pickup from Mumbai Airport for travelers heading to Bhopal." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Verma",
    feedback:
      "We booked Omshree Cabs for our Mumbai to Bhopal journey. The driver was professional and the vehicle was comfortable for the long trip.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Sharma",
    feedback:
      "Excellent intercity cab service. Smooth travel from Mumbai to Bhopal with a clean vehicle and punctual driver.",
    rating: 5
  }
];











































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Bhopal Cab",
  "description": "Omshree Cab provides reliable cab services from Mumbai to Bhopal for one-way and round trips. Travel comfortably with Innova, Ertiga, Sedan, and other well-maintained vehicles for business, leisure, or family trips. Enjoy safe, punctual, and convenient journeys with flexible booking options and transparent pricing.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "1100"
  }
};







  return (
    <div>
      
<Helmet>
  <title>Mumbai to Bhopal Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab offers cab services from Mumbai to Bhopal for one-way and round trips. Travel in comfort with Innova, Ertiga, and Sedan vehicles. Safe, punctual, and convenient journeys with flexible booking options and transparent pricing." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/64.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitobhopalcab;